<template>
  <div class="box">
    <v-row>
      <v-col cols="12">
        <v-expansion-panels :value="panel" accordion multiple hover tile readonly>
          <v-expansion-panel :style="upperPanelHeight">
            <v-expansion-panel-header hide-actions>Role</v-expansion-panel-header>
            <v-expansion-panel-content>
              <!-- eslint-disable-next-line prettier/prettier -->
              <tree-data-table
                :headers="roleHeaders" :items="roleTree" item-key="label" :height="upperTableHeight"
                @click:row="arrangeTcodCompGrid"
                dense hide-default-footer disable-pagination fixed-header single-select>
                <template #item.isComposite="{ value }"> {{ value == 'C' ? 'Composite' : 'Single' }} </template>
                <template #item.statusColor="{ item }">
                  <v-tooltip content-class="tooltip" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" :style="cssStatusColor(item.statusColor)" small>mdi-circle</v-icon>
                    </template>
                    <p>
                      <span style="font-weight:bold" small>{{ $t('rtrck.field.title.role.status') }}</span>
                    </p>
                    <span small>{{ item.statusMessage }}</span>
                  </v-tooltip>
                </template>
                <template #item.userStatusColor="{ item }">
                  <v-tooltip content-class="tooltip" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" :style="cssStatusColor(item.userStatusColor)" small>mdi-circle</v-icon>
                    </template>
                    <p>
                      <span style="font-weight:bold" small>{{ $t('rtrck.field.title.role.user.status') }}</span>
                    </p>
                    <span small>{{ item.userStatusMessage }}</span>
                  </v-tooltip>
                </template>
                <template #item.changeDatim="{ value }"> {{ value | format('yyyy-MM-dd') }} </template>
                <template #item.assignDatim="{ value }"> {{ value | format('yyyy-MM-dd') }} </template>
                <template #item.period="{ item }"> {{ item.fromDatim | format('yyyy-MM-dd') }} ~ {{ item.toDatim | format('yyyy-MM-dd') }} </template>
              </tree-data-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel :style="lowerPanelHeight">
            <v-expansion-panel-header hide-actions>T-Code</v-expansion-panel-header>
            <v-expansion-panel-content>
              <!-- eslint-disable-next-line prettier/prettier -->
              <v-data-table
                :headers="tcodCompHeaders" :items="tcodCompGrid" item-key="label" :height="lowerTableHeight" :loading="loading"
                dense hide-default-footer disable-pagination fixed-header single-select>
                <template #item.notInAuthMap="{ value }">
                  <v-icon small :style="cssStatusColor(value.circleColor)">mdi-circle</v-icon>
                  <span :style="cssStatusLabel(value.labelForeColor)">{{ value.label ? value.label : '' }}</span>
                </template>
                <template #item.notInMenuMap="{ value }">
                  <v-icon small :style="cssStatusColor(value.circleColor)">mdi-circle</v-icon>
                  <span :style="cssStatusLabel(value.labelForeColor)">{{ value.label ? value.label : '' }}</span>
                </template>
              </v-data-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { api } from '@/api/common/instances';
import share from './searchShare.js';
export default {
  props: {
    height: {
      type: Number,
    },
    roleTree: {
      type: Array,
    },
  },
  mixins: [share],
  data() {
    return {
      // data 'panel'은 내부의 panel 모두가 디폴트로 펼쳐져서 content가 보이게 하기 위한 조치.
      panel: [0, 1],
      tcodCompHeaders: [
        { text: 'Description', value: 'menuText', width: '25%', expandable: true, sortable: false },
        { text: 'T-Code in menu', value: 'menuTcode', sortable: false },
        { text: 'Status', value: 'notInAuthMap', sortable: false },
        { text: '', value: 'gap', sortable: false },
        { text: 'Status', value: 'notInMenuMap', sortable: false },
        { text: 'T-Code in authorization', value: 'authTcode', sortable: false },
        { text: 'Description', value: 'authText', sortable: false },
      ],
      tcodCompGrid: [],
      loading: false,
    };
  },
  methods: {
    async arrangeTcodCompGrid(node, { select, selected }) {
      select(!selected);
      // Authorization은 single role의 profile에만 존재함.
      // Composite profile은 generation된 single profile을 갖지 않음.
      if (node.isComposite != 'S') {
        this.tcodCompGrid = [];
        return;
      }
      this.loading = true;
      const { data } = await api.get('/rtrck/search/tcod-comp', {
        params: {
          svrYmdhms: node.svrYmdhms,
          sstmId: node.sstmId,
          mandt: node.mandt,
          agrName: node.agrName,
        },
      });
      // console.log('in TcodeCompare arrangeTcodCompGrid()... data=', data);
      this.tcodCompGrid = data;
      this.loading = false;
    },
    cssStatusLabel(color) {
      // 원래 서버에서 '#FF0000'를 내려주는데 이는 dark 테마에서 잘 안보인다.
      if (this.$vuetify.theme.isDark) return `padding-left: 10px; color: #FF6666;`;
      return `padding-left: 10px; color: ${color};`;
    },
  },
};
</script>

<style lang="scss" scoped>
.v-expansion-panel-content ::v-deep .v-expansion-panel-content__wrap {
  padding: 0;
}
</style>
